import React from 'react'
import { useIntl } from 'react-intl'

import { LanguageMenu } from './language-menu'
import { useLanguageSwitch } from '../../../../hooks/use-language-switch'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../../shadcn/components/ui/dialog'

export function LanguageSwitchModal({
  pathname,
  searchParams,
}: {
  pathname: string
  searchParams: string
}) {
  const intl = useIntl()
  const { isOpen, handleClose } = useLanguageSwitch()

  const title = intl.formatMessage({
    id: 'ui.languageSwitchModal.title',
    defaultMessage: 'Sélectionnez votre pays ou région',
  })

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent data-testid='modal'>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className='sr-only'>{title}</DialogDescription>
        </DialogHeader>
        <DialogBody>
          <LanguageMenu pathname={pathname} searchParams={searchParams} />
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}
